import MatchCard from "../matchCard/matchCard";
import WinnerDisplay from "../winnerDisplay";
import "./thirdPlace.sass";

export default function ThirdPlace({ match, onSelectWinner }) {
  if (!match) return null;

  return (
    <div className="ThirdPlacePhase">
      <div className="RoundTitle"><p>TERCER LUGAR</p></div>
      <MatchCard match={match} onSelectWinner={onSelectWinner} />
      <WinnerDisplay winner={match.winner} variant="thirdPlace" />
    </div>
  );
}